import { ApiView } from '@e3dc-react/shell/Elements/ApiView'
import React, { useState } from 'react'
import { useCompanyTableData } from '../hooks/use-company-table-data'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { makeStyles } from 'tss-react/mui'
import { Box } from '@mui/material'
import { CompanyConnectedRecordDto } from '../api/dto'
import { getPartnerNumberWithoutSpaces } from '../functions'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(4),
    },
  },
  tableHeader: {
    whiteSpace: 'pre-line',
  },
  bodyClassName: {
    '&:hover > td': {
      opacity: 1,
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.dark,
    },
  },
}))

const COMPANY_FILTERS: (keyof CompanyConnectedRecordDto)[] = [
  'firma.Name',
  'firma.partnerNumber',
  'manager.Name',
  'manager.Email',
  'location.Address',
  'location.PLZ',
  'location.PlaceOR',
]

/**
 * This component shows a table of the companies
 */
const CompanyOverview: React.VFC = () => {
  const { classes } = useStyles()
  const { columns, fetchProps } = useCompanyTableData()
  const { t } = useCustomTranslation()
  const [filterQuery, setFilterQuery] = useState('')

  return (
    <Box className={classes.container}>
      <ApiView<CompanyConnectedRecordDto>
        fetchProps={fetchProps}
        tableColumns={columns}
        isMobilePaginator={true}
        onlyTable
        hasColoredTableColumns
        bodyElevation={0}
        footerElevation={0}
        headerElevation={0}
        headerClassName={classes.tableHeader}
        bodyClassName={classes.bodyClassName}
        oneFilter={{
          properties: COMPANY_FILTERS,
          label: t('common.search'),
          filterQuery,
          setFilterQuery,
          customFilterValueTransformer: getPartnerNumberWithoutSpaces,
          urlParams: {
            enabled: true,
          },
        }}
      />
    </Box>
  )
}

export default CompanyOverview
